var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompanyIcon = function SvgCompanyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CompanyIcn",
    transform: "translate(-677.722 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 24,
    height: 24,
    rx: 6,
    transform: "translate(677.722 -5)",
    fill: "#3953fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "corporate_fare_FILL0_wght300_GRAD0_opsz20",
    d: "M110.616,278.978v-11.9h6.9v2.729h7.1v9.172Zm.985-.985h4.927v-1.743H111.6Zm0-2.729h4.927V273.52H111.6Zm0-2.729h4.927v-1.743H111.6Zm0-2.729h4.927v-1.743H111.6Zm5.913,8.187h6.117v-7.2h-6.117Zm1.51-4.472v-.985h2.95v.985Zm0,2.729v-.985h2.95v.985Z",
    transform: "translate(572.106 -266.028)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/companyIcon.c2f3da88.svg";
export { ForwardRef as ReactComponent };